<div class="proposal-answer container">
    <div class="row">
        <h1>
            <i class="fa fa-search" aria-hidden="true"></i>
            {{ 'session-proposal-answer.title' | translate }}
        </h1>
        <div class="col-sm-5">
            <h2>{{ 'session-proposal-answer.title-standard' | translate }}</h2>
            <div *ngIf="
                    standardSessionProposalAnswers &&
                    standardSessionProposalAnswers.length > 0
                ">
                <div *ngFor="
                        let answer of standardSessionProposalAnswers;
                        let i = index
                    ">
                    <div class="row">
                        <a class="card" uiSref="session-detail" [uiParams]="{
                                id: standardSessionProposalAnswers[i].sessionId
                            }">
                            <div class="row">
                                <div class="col-xs-6 title">
                                    {{ answer.title }}
                                </div>
                                <div class="col-xs-6 date">
                                    {{ answer.startDate | date: 'dd/MM/yyyy' }}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12">
                                    {{ evaluateType(answer.type) }}
                                    {{ answer.duration }}
                                    {{
                                        'session-proposal-answer.days'
                                            | translate
                                    }}
                                    <span *ngIf="answer.location">
                                        {{ answer.location.city }}
                                    </span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-8 answer">
                                   <span *ngIf="answer.answer === 'YES_NO_MISSIONS'" aria-hidden="true">
                                        {{
                                            'global.staffing-result-answer-icons.yes-no-missions-icon'
                                                | translate
                                       }}
                                    </span>
                                    <span *ngIf="answer.answer === 'YES'" aria-hidden="true">
                                        {{
                                            'global.staffing-result-answer-icons.yes-icon'
                                                | translate
                                        }}
                                    </span>
                                    <span *ngIf="
                                            answer.answer === 'YES_DATE_CHANGED'
                                        " aria-hidden="true">
                                        {{
                                            'global.staffing-result-answer-icons.yes-date-changed-icon'
                                                | translate
                                        }}
                                    </span>
                                    <span *ngIf="
                                            answer.answer === 'YES_NOT_READY'
                                        " aria-hidden="true">
                                        {{
                                            'global.staffing-result-answer-icons.yes-not-ready-icon'
                                                | translate
                                        }}
                                    </span>
                                    <span *ngIf="
                                            answer.answer ===
                                            'NO_CLIENT_CONSTRAINT'
                                        " aria-hidden="true">
                                        {{
                                            'global.staffing-result-answer-icons.no-client-constraint-icon'
                                                | translate
                                        }}
                                    </span>
                                    <span *ngIf="
                                            answer.answer ===
                                            'NO_WRONG_TRAINING'
                                        " aria-hidden="true">
                                        {{
                                            'global.staffing-result-answer-icons.no-wrong-training-icon'
                                                | translate
                                        }}
                                    </span>
                                    <span *ngIf="answer.answer === 'NO'" aria-hidden="true">
                                        {{
                                            'global.staffing-result-answer-icons.no-icon'
                                                | translate
                                        }}
                                    </span>
                                    <span *ngIf="answer.answer === 'NO_TOO_FAR'" aria-hidden="true">
                                        {{'global.staffing-result-answer-icons.no-too-far-icon' | translate}}
                                    </span>
                                    {{answer.trainerName}}
                                </div>
                                <div class="col-xs-4 answer-date">
                                    {{
                                        answer.answerDate
                                            | date: 'dd/MM/yyyy HH:mm'
                                    }}
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-5 col-sm-offset-2">
            <h2>{{ 'session-proposal-answer.title-virtual' | translate }}</h2>
            <div *ngFor="let answer of virtualSessionProposalAnswers">
                <div class="row">
                    <a class="card" uiSref="session-staffing-detail" [uiParams]="{ id: answer.virtualSessionId }">
                        <div class="row">
                            <div class="col-xs-6 title">
                                {{ answer.title }}
                            </div>
                            <div class="col-xs-6 date">
                                {{ answer.estimationDate }}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-8 answer">
                                <span *ngIf="answer.answer === 'YES_NO_MISSIONS'" aria-hidden="true">
                                    {{'global.staffing-result-answer-icons.yes-no-missions-icon' | translate}}
                                </span>
                                <span *ngIf="answer.answer === 'YES'" aria-hidden="true">
                                    {{'global.staffing-result-answer-icons.yes-icon' | translate}}
                                </span>
                                <span *ngIf="answer.answer === 'YES_DATE_CHANGED'" aria-hidden="true">
                                    {{'global.staffing-result-answer-icons.yes-date-changed-icon' | translate}}
                                </span>
                                <span *ngIf="answer.answer === 'YES_NOT_READY'" aria-hidden="true">
                                    {{'global.staffing-result-answer-icons.yes-not-ready-icon' | translate}}
                                </span>
                                <span *ngIf="answer.answer === 'NO_CLIENT_CONSTRAINT'" aria-hidden="true">
                                    {{'global.staffing-result-answer-icons.no-client-constraint-icon' | translate}}
                                </span>
                                <span *ngIf="answer.answer === 'NO_WRONG_TRAINING'" aria-hidden="true">
                                    {{'global.staffing-result-answer-icons.no-wrong-training-icon' | translate}}
                                </span>
                                <span *ngIf="answer.answer === 'NO'" aria-hidden="true">
                                    {{'global.staffing-result-answer-icons.no-icon' | translate}}
                                </span>
                                <span *ngIf="answer.answer === 'NO_TOO_FAR'" aria-hidden="true">
                                    {{'global.staffing-result-answer-icons.no-too-far-icon' | translate}}
                                </span>
                                {{answer.trainerName}}
                            </div>
                            <div class="col-xs-4 answer-date">
                                {{ answer.answerDate | date: 'dd/MM/yy HH:mm' }}
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/session/staffing-answers/proposal.component.html